import type { ParagraphThreeBoxes as ParagraphThreeBoxesData } from "@/lib/api/cms-catalog";
import type { ParagraphTranslations } from "../Paragraph.i18n";
import { Attachments } from "../shared/Attachments";
import { Box } from "../shared/Box";
import styles from "../Paragraph.module.css";

/**
 * Layout 18 — `PARAGRAPH_THREE_BOXES_LAYOUT`: 3 boksy z obrazem + tytułem + CTA.
 *
 * Tytuły per boks: `name` -> boks 1, `name_1` -> boks 2, `name_2` -> boks 3.
 * Brak nadrzędnego nagłówka akapitu (`ParagraphHeading`) - boksy same niosą tytuły.
 */
export function ParagraphThreeBoxes({
  paragraph,
  t,
}: {
  paragraph: ParagraphThreeBoxesData;
  t: ParagraphTranslations;
}) {
  return (
    <section className={styles.paragraph}>
      <div className={`${styles.boxes} ${styles.boxesThree}`}>
        <Box
          name={paragraph.name}
          text={paragraph.text}
          image={paragraph.image}
          color={paragraph.color}
          buttonName={paragraph.button_name}
          buttonUrl={paragraph.button_url}
        />
        <Box
          name={paragraph.name_1}
          text={paragraph.text_1}
          image={paragraph.image_1}
          color={paragraph.color_1}
          buttonName={paragraph.button_name_1}
          buttonUrl={paragraph.button_url_1}
        />
        <Box
          name={paragraph.name_2}
          text={paragraph.text_2}
          image={paragraph.image_2}
          color={paragraph.color_2}
          buttonName={paragraph.button_name_2}
          buttonUrl={paragraph.button_url_2}
        />
      </div>
      <Attachments files={paragraph.attachments} t={t} />
    </section>
  );
}

